<template>
  <div>
    <div class="contact-page">
    <div class="contact-container">
      <!-- Left Column -->
      <div class='column' id="main">
        <h1 class="contact-title" v-html="$t('contact.title')"></h1>
        <p class="contact-description" v-html="descriptionHtml"></p>
        <!-- <img class="background-image" src="/img/MegaGrantsPoster.png" /> -->
      </div>
      <!-- Right Column -->
      <div class='column' id="side">
       
        <iframe 
          src="https://docs.google.com/forms/d/e/1FAIpQLSfbRuXJI8JJliuQsVHQC4iuJ4eDFXPgyBq23taFSa7vgQykww/viewform?embedded=true&hl=en"
          width="100%"
          height="1550"
          style="border:none; background:#232323; border-radius: 10px; overflow: hidden; "
        >Loading...</iframe>

      </div>
    </div>
  </div>
    
    <div class="section section-contact-us text-center">

      <div class="container">
        <div class="row">
          <div class="col-md-8 ml-auto mr-auto text-center">
            <h2 class="title" style="color: white;">{{$t('about.contact')}}</h2>
            <h5 class="description" style="color: white;">
              <p>{{$t('about.address')}}</p>
              <p>{{$t('about.address_2')}}</p>
              <!-- "泛太丝亚企业管理顾问（上海）有限公司 -->
              <p>Red Pill Lab Limited, Central, Hong Kong</p>
              <p>Email: contact@rplab.ai / support@rplab.ai / sales@rplab.ai</p>
              <!-- <p>{{$t('about.phone')}}</p> -->
            </h5>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button, FormGroupInput } from '@/components';
export default {
  name: 'contact',
  bodyClass: 'landing-page',
  components: {
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  computed: {
    descriptionHtml() {
      return this.$t('contact.description').join('\n');
    }
  },
  data() {
    return {
      form: {
        firstName: '',
        email: '',
        message: ''
      }
    };
  }
};
</script>
<style scoped>

.contact-container {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: flex-start;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 20px 40px 20px;
  gap: 48px;
}
.contact-left {
  flex: 1 1 0;
  max-width: 520px;
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.contact-title {
  font-size: 2.8rem;
  font-weight: 800;
  line-height: 1.1;
  margin-bottom: 24px;
  letter-spacing: -1px;
}
.contact-description {
  font-size: 1.1rem;
  margin-bottom: 32px;
  color: #ffffff;
  font-weight: 400;
}
.contact-image {
  width: 100%;
  max-width: 400px;
  border-radius: 12px;
  margin-top: 24px;
  box-shadow: 0 4px 24px rgba(0,0,0,0.3);
}
.contact-right {
  flex: 1 1 0;
  max-width: 420px;
  background: transparent;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
@media (max-width: 900px) {
  .contact-container {
    flex-direction: column;
    align-items: center;
    gap: 32px;
  }
  .contact-left, .contact-right {
    max-width: 100%;
  }
  .contact-image {
    max-width: 100%;
  }
}
</style>
